import { Serializable } from '../../model/sidebar-query-params.model';

export class StringSerializerBase implements Serializable<string> {
  deserialize(value: string): string {
    return value;
  }

  serialize(value: string): string {
    return value;
  }
}
